<template>

    <transition
        name="cta-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut">

        <!-- OVERLAY - POWER SURGE -->
        <div class="overlay" v-if="powerSurgeOverlay"></div>
        <!-- END OVERLAY - POWER SURGE -->

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'power-surge-overlay',

        components: {},

        data() {
            return {

            }
        },

        computed: {

            powerSurgeOverlay() {
                return this.$dataStore.state.interactive.powerSurgeOverlay;
            }

        },

        watch: {
            powerSurge: function(nVal, oVal) {
                // add/kill event listener
                if (nVal) {
                    document.addEventListener('keyup', vm.handleKeys, false);
                } else {
                    document.removeEventListener('keyup', vm.handleKeys, false);
                }
            }
        },

        created() {
            vm = this;
        },

        mounted() {
            vm = this;
        },

        methods: {

            /**
             * @method handleKeys
             * @description
             * @param {Object} evt
             */
            handleKeys(evt) {

                switch(evt.keyCode) {
                    case 27: // ESC
                        this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                        this.$dataStore.dispatch('POWER_SURGE', { val: false });
                        this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                        this.$eventBus.$emit('power-surge:end');
                        this.$dataStore.dispatch('PANEL_OPEN', { val: false });
                        this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });
                        break;
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .overlay {
        background-color: $black-40;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        pointer-events: none;
        animation-duration: 0.6s;
        animation-delay: 0.3s;
    }

</style>


// WEBPACK FOOTER //
// PowerSurgeOverlay.vue?0a70ac6e